/**
 * stone-tutorial.js - 石の選び方インタラクティブチュートリアル
 * 実際に操作させて、ガーネット追加→パレット開く→診断タブ→タロット→2石選択→カスタマイズ開始→フレーム選択で終了
 */
(function() {
  'use strict';

  var OVERLAY_Z = 9998;
  var SPOTLIGHT_PADDING = 12;
  var ANIM_DURATION = 400;
  var SCROLL_DURATION = 400;
  var MOBILE_BOTTOM_NAV = 72;

  function isMobile() {
    return window.innerWidth <= 768;
  }

  function smoothScrollTo(y, duration) {
    duration = duration || SCROLL_DURATION;
    var start = window.pageYOffset || document.documentElement.scrollTop;
    var startTime = performance.now();
    function step(now) {
      var elapsed = now - startTime;
      var progress = Math.min(elapsed / duration, 1);
      var ease = 1 - Math.pow(1 - progress, 3);
      window.scrollTo(0, start + (y - start) * ease);
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function scrollToElement(el, block) {
    if (!el) return;
    block = block || 'center';
    var r = el.getBoundingClientRect();
    var targetY = r.top + window.pageYOffset;
    if (block === 'center') targetY -= (window.innerHeight / 2) - (r.height / 2);
    targetY = Math.max(0, Math.min(targetY, document.documentElement.scrollHeight - window.innerHeight));
    smoothScrollTo(targetY, SCROLL_DURATION);
  }

  function updateSpotlightMobileSafe(overlay, el) {
    if (isMobile()) {
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          void document.body.offsetHeight;
          setTimeout(function() {
            updateSpotlight(overlay, el);
            requestAnimationFrame(function() { updateSpotlight(overlay, el); });
          }, 50);
        });
      });
    } else {
      updateSpotlight(overlay, el);
    }
  }

  function getStr(key) {
    return (window.hoshikiStrings && window.hoshikiStrings[key]) || key;
  }

  function ensureScriptsLoaded() {
    if (window.HoshikiPreload && window.HoshikiPreload.loadScripts) {
      return window.HoshikiPreload.loadScripts(['tarot', 'utils', 'data', 'palette', 'gem', 'personal_diagnosis']);
    }
    if (window.HoshikiLanding && window.HoshikiLanding.loadScript) {
      return Promise.all([
        window.HoshikiLanding.loadScript('gem'),
        window.HoshikiLanding.loadScript('diagnosis'),
        window.HoshikiLanding.loadScript('palette')
      ]);
    }
    return Promise.resolve();
  }

  function waitForGems() {
    return new Promise(function(resolve) {
      var list = document.getElementById('hoshiki-gem-list');
      if (!list) { resolve(); return; }
      if (list.querySelector('.h-gem-palette-btn')) { resolve(); return; }
      document.addEventListener('hoshikiGemsLoaded', function h() {
        document.removeEventListener('hoshikiGemsLoaded', h);
        resolve();
      });
      setTimeout(resolve, 3000);
    });
  }

  function getGarnetPaletteBtn() {
    var variants = window.hoshikiGemProduct && window.hoshikiGemProduct.variants && window.hoshikiGemProduct.variants.edges;
    if (!variants || !window.HoshikiUtils || !window.HoshikiUtils.resolveVariantByEnName) return null;
    var nodes = variants.map(function(e) { return e.node; });
    var garnetVariant = window.HoshikiUtils.resolveVariantByEnName('Garnet', nodes);
    if (!garnetVariant) return null;
    var btn = document.querySelector('.h-gem-palette-btn[data-node-id="' + garnetVariant.id + '"]');
    if (btn) return btn;
    var btns = document.querySelectorAll('#hoshiki-gem-list .h-gem-palette-btn');
    for (var i = 0; i < btns.length; i++) {
      var nid = btns[i].getAttribute('data-node-id');
      if (nid && garnetVariant.id && String(nid) === String(garnetVariant.id)) return btns[i];
    }
    return btns[0] || null;
  }

  function resolveGarnetSpotlightTarget(btn, section) {
    if (!btn) return section;
    var card = btn.closest('.h-gem-card') || btn.closest('.h-gem-item');
    if (isMobile() && card) {
      var cr = card.getBoundingClientRect();
      if (cr.width >= 20 && cr.height >= 20) return card;
    }
    var r = btn.getBoundingClientRect();
    if (r.width >= 20 && r.height >= 20) return btn;
    if (card) {
      var cr = card.getBoundingClientRect();
      if (cr.width >= 20 && cr.height >= 20) return card;
    }
    return section;
  }

  function isGarnetInPalette() {
    if (!window.HoshikiPalette || !window.HoshikiPalette.getPalette) return false;
    var list = window.HoshikiPalette.getPalette();
    var variants = window.hoshikiGemProduct && window.hoshikiGemProduct.variants && window.hoshikiGemProduct.variants.edges;
    if (!variants) return false;
    var nodes = variants.map(function(e) { return e.node; });
    var garnet = window.HoshikiUtils && window.HoshikiUtils.resolveVariantByEnName ? window.HoshikiUtils.resolveVariantByEnName('Garnet', nodes) : null;
    if (!garnet) return false;
    var gid = String(garnet.id).replace(/^.*\/(\d+)$/, '$1');
    for (var i = 0; i < list.length; i++) {
      var ids = list[i].stoneIds || [];
      for (var j = 0; j < ids.length; j++) {
        var sid = String(ids[j]).replace(/^.*\/(\d+)$/, '$1');
        if (sid === gid) return true;
      }
    }
    return false;
  }

  function createOverlay(onSkip) {
    var wrap = document.createElement('div');
    wrap.id = 'stone-tutorial-overlay';
    wrap.className = 'stone-tutorial-overlay';
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-label', 'Tutorial');
    wrap.innerHTML = '<div id="stone-tutorial-click-intercept" class="stone-tutorial-click-intercept" aria-hidden="true"></div>' +
      '<div class="stone-tutorial-spotlight-top"></div><div class="stone-tutorial-spotlight-right"></div><div class="stone-tutorial-spotlight-bottom"></div><div class="stone-tutorial-spotlight-left"></div>' +
      '<button type="button" id="stone-tutorial-skip-fixed" class="stone-tutorial-skip-fixed">' + getStr('tutorial_skip') + '</button>';
    var skipBtn = wrap.querySelector('#stone-tutorial-skip-fixed');
    if (skipBtn && onSkip) skipBtn.addEventListener('click', onSkip);
    return wrap;
  }

  function createBubble(text, onNext, onSkip, nextLabel) {
    var label = (nextLabel != null ? nextLabel : getStr('tutorial_next'));
    var bubble = document.createElement('div');
    bubble.className = 'stone-tutorial-bubble';
    bubble.innerHTML = '<div class="stone-tutorial-bubble-text">' + (text || '').replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</div>' +
      '<div class="stone-tutorial-bubble-actions">' +
      (onNext ? '<button type="button" class="stone-tutorial-btn stone-tutorial-next">' + (label || '').replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</button>' : '');
    if (onNext && bubble.querySelector('.stone-tutorial-next')) {
      bubble.querySelector('.stone-tutorial-next').addEventListener('click', onNext);
    }
    return bubble;
  }

  function createFrameDoneBubble(text, onEndClick) {
    var bubble = document.createElement('div');
    bubble.className = 'stone-tutorial-bubble stone-tutorial-frame-bubble';
    var endLabel = getStr('tutorial_end_finish') || 'チュートリアルを終了';
    bubble.innerHTML = '<div class="stone-tutorial-bubble-text">' + (text || '').replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</div>' +
      '<div class="stone-tutorial-bubble-actions">' +
      '<button type="button" class="stone-tutorial-btn stone-tutorial-end">' + (endLabel || '').replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</button>';
    if (onEndClick && bubble.querySelector('.stone-tutorial-end')) {
      bubble.querySelector('.stone-tutorial-end').addEventListener('click', onEndClick);
    }
    return bubble;
  }

  function updateSpotlight(overlay, el) {
    var parts = ['top', 'right', 'bottom', 'left'].map(function(p) {
      return overlay.querySelector('.stone-tutorial-spotlight-' + p);
    });
    if (!el || !el.getBoundingClientRect) {
      parts.forEach(function(p) { if (p) p.style.display = 'none'; });
      return;
    }
    if (isMobile()) {
      void document.body.offsetHeight;
    }
    var r = el.getBoundingClientRect();
    var minSize = 48;
    if (r.width < 20 || r.height < 20) {
      var cx = r.left + r.width / 2;
      var cy = r.top + r.height / 2;
      r = {
        left: cx - minSize / 2,
        top: cy - minSize / 2,
        right: cx + minSize / 2,
        bottom: cy + minSize / 2,
        width: minSize,
        height: minSize
      };
    }
    var pad = isMobile() ? 8 : SPOTLIGHT_PADDING;
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    var y0 = Math.max(0, r.top - pad);
    var y1 = Math.min(vh, r.bottom + pad);
    var x0 = Math.max(0, r.left - pad);
    var x1 = Math.min(vw, r.right + pad);
    if (isMobile()) {
      if (y1 <= y0) { y0 = Math.max(0, Math.min(vh - 80, r.top - pad)); y1 = Math.min(vh, y0 + 80); }
      if (x1 <= x0) { x0 = Math.max(0, Math.min(vw - 80, r.left - pad)); x1 = Math.min(vw, x0 + 80); }
      y0 = Math.min(y0, vh - 2);
      y1 = Math.max(y1, y0 + 2);
      x0 = Math.min(x0, vw - 2);
      x1 = Math.max(x1, x0 + 2);
    }
    var mobileExtra = isMobile() ? ';position:fixed;visibility:visible;opacity:1;-webkit-transform:translateZ(0);transform:translateZ(0)' : '';
    parts[0].style.cssText = 'top:0;left:0;width:' + vw + 'px;height:' + y0 + 'px;display:block' + mobileExtra + ';';
    parts[1].style.cssText = 'top:' + y0 + 'px;left:' + x1 + 'px;width:' + Math.max(0, vw - x1) + 'px;height:' + Math.max(1, y1 - y0) + 'px;display:block' + mobileExtra + ';';
    parts[2].style.cssText = 'top:' + y1 + 'px;left:0;width:' + vw + 'px;height:' + Math.max(0, vh - y1) + 'px;display:block' + mobileExtra + ';';
    parts[3].style.cssText = 'top:' + y0 + 'px;left:0;width:' + x0 + 'px;height:' + Math.max(1, y1 - y0) + 'px;display:block' + mobileExtra + ';';
  }

  function positionBubble(bubble, targetEl) {
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    var br = bubble.getBoundingClientRect();
    var pad = isMobile() ? 16 : 24;
    var bottomPad = isMobile() ? (MOBILE_BOTTOM_NAV + 100) : pad;
    var x = (vw - br.width) / 2;
    var y;
    if (targetEl && targetEl.getBoundingClientRect) {
      var tr = targetEl.getBoundingClientRect();
      var targetCenter = tr.top + tr.height / 2;
      if (targetCenter > vh / 2) {
        y = Math.max(pad, tr.top - br.height - pad);
      } else {
        y = Math.min(vh - br.height - bottomPad, tr.bottom + pad);
      }
    } else {
      y = (vh - br.height) / 2;
    }
    y = Math.max(pad, Math.min(vh - br.height - bottomPad, y));
    bubble.style.left = Math.max(pad, Math.min(vw - br.width - pad, x)) + 'px';
    bubble.style.top = y + 'px';
  }

  function clickTab(tabKey) {
    var tab = document.querySelector('.tab-link[data-tab="' + tabKey + '"]');
    if (tab) tab.click();
  }

  function openPalette() {
    var fab = document.getElementById('palette-fab');
    var modal = document.getElementById('palette-modal');
    if (fab && modal && modal.style.display !== 'block') fab.click();
  }

  function runTutorial() {
    var trigger = document.getElementById('stone-tutorial-trigger');
    if (!trigger) return;
    trigger.disabled = true;

    ensureScriptsLoaded().then(function() {
      if (window.HoshikiPreload && window.HoshikiPreload.trigger) {
        var gs = document.querySelector('[data-preload="gem"]');
        var ds = document.querySelector('[data-preload="diagnosis"]');
        if (gs) window.HoshikiPreload.trigger(gs);
        if (ds) window.HoshikiPreload.trigger(ds);
      }
      return waitForGems();
    }).then(function() {
      if (window.HoshikiPalette && window.HoshikiPalette.removeByStoneIds && window.hoshikiGemProduct && window.hoshikiGemProduct.variants) {
        var nodes = window.hoshikiGemProduct.variants.edges.map(function(e) { return e.node; });
        var garnet = window.HoshikiUtils && window.HoshikiUtils.resolveVariantByEnName ? window.HoshikiUtils.resolveVariantByEnName('Garnet', nodes) : null;
        if (garnet) {
          ['gem_library', 'diagnosis_mbti', 'diagnosis_birthstone', 'diagnosis_tarot'].forEach(function(sk) {
            window.HoshikiPalette.removeByStoneIds([garnet.id], sk);
          });
        }
      }
      function endTutorial() {
        if (bubble) bubble.remove();
        bubble = null;
        resizeCb && window.removeEventListener('resize', resizeCb);
        document.body.classList.remove('no-scroll');
        overlay.classList.remove('stone-tutorial-overlay-visible');
        if (window.HoshikiPalette && window.HoshikiPalette.closePalette && window.HoshikiPalette.isPaletteOpen && window.HoshikiPalette.isPaletteOpen()) {
          window.HoshikiPalette.closePalette();
        }
        setTimeout(function() { overlay.remove(); trigger.disabled = false; }, 300);
      }
      var overlay = createOverlay(endTutorial);
      document.body.appendChild(overlay);
      document.body.classList.add('no-scroll');
      overlay.classList.add('stone-tutorial-overlay-visible');
      if (isMobile()) overlay.classList.add('stone-tutorial-mobile');

      var bubble = null;
      var resizeCb = null;
      var allowedTargets = null;

      function setAllowedTargets(targets) {
        allowedTargets = targets;
      }

      function isClickAllowed(el) {
        if (!el) return false;
        if (el.closest('#stone-tutorial-skip-fixed')) return true;
        if (el.closest('.stone-tutorial-bubble')) return true;
        if (!allowedTargets) return false;
        if (typeof allowedTargets === 'function') return allowedTargets(el);
        var arr = Array.isArray(allowedTargets) ? allowedTargets : [allowedTargets];
        for (var i = 0; i < arr.length; i++) {
          var t = arr[i];
          if (t && (el === t || t.contains(el))) return true;
        }
        return false;
      }

      var interceptEl = overlay.querySelector('#stone-tutorial-click-intercept');
      if (interceptEl) {
        interceptEl.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          interceptEl.style.pointerEvents = 'none';
          var under = document.elementFromPoint(e.clientX, e.clientY);
          interceptEl.style.pointerEvents = 'auto';
          if (isClickAllowed(under)) {
            under.click();
          }
        }, true);
        interceptEl.addEventListener('touchend', function(e) {
          if (e.changedTouches.length !== 1) return;
          var x = e.changedTouches[0].clientX;
          var y = e.changedTouches[0].clientY;
          interceptEl.style.pointerEvents = 'none';
          var under = document.elementFromPoint(x, y);
          interceptEl.style.pointerEvents = 'auto';
          if (!isClickAllowed(under)) {
            e.preventDefault();
            e.stopPropagation();
          }
        }, { passive: false, capture: true });
      }

      function showBubble(text, targetEl, showNext, onNext, onSkip, nextLabel) {
        if (bubble) { bubble.remove(); resizeCb && window.removeEventListener('resize', resizeCb); }
        bubble = createBubble(text, showNext ? onNext : null, onSkip, nextLabel);
        document.body.appendChild(bubble);
        positionBubble(bubble, targetEl);
        resizeCb = function() { positionBubble(bubble, targetEl); };
        window.addEventListener('resize', resizeCb);
      }

      function isSpotlightPart(el) {
        return el && (el.classList.contains('stone-tutorial-spotlight-top') || el.classList.contains('stone-tutorial-spotlight-right') ||
            el.classList.contains('stone-tutorial-spotlight-bottom') || el.classList.contains('stone-tutorial-spotlight-left'));
      }
      overlay.addEventListener('click', function(e) {
        if (isSpotlightPart(e.target)) {
          e.preventDefault();
          e.stopPropagation();
        }
      });
      overlay.addEventListener('touchstart', function(e) {
        if (isSpotlightPart(e.target)) e.preventDefault();
      }, { passive: false });

      // Step 1: ガーネットを追加
      function step1() {
        var section = document.querySelector('[data-preload="gem"]') || document.querySelector('.h-gem-container');
        var btn = getGarnetPaletteBtn();
        if (section) scrollToElement(section, isMobile() ? 'start' : 'center');
        if (btn && isMobile()) {
          setTimeout(function() {
            try { btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); } catch (e) { btn.scrollIntoView(true); }
          }, 100);
        }
        var step1Delay = isMobile() ? 1100 : (ANIM_DURATION + 50);
        setTimeout(function() {
          btn = getGarnetPaletteBtn();
          var spotlightTarget = resolveGarnetSpotlightTarget(btn, section);
          function doStep1Spotlight() {
            if (isMobile()) {
              requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                  void document.body.offsetHeight;
                  setTimeout(function() {
                    updateSpotlight(overlay, spotlightTarget);
                    requestAnimationFrame(function() { updateSpotlight(overlay, spotlightTarget); });
                  }, 50);
                });
              });
            } else {
              requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                  updateSpotlight(overlay, spotlightTarget);
                });
              });
            }
          }
          doStep1Spotlight();
          setAllowedTargets(btn || null);
          showBubble(getStr('tutorial_add_garnet'), spotlightTarget, false, null, endTutorial);
          if (btn) {
            var check = function() {
              if (isGarnetInPalette()) {
                document.removeEventListener('hoshiki:palette:updated', check);
                step2();
              }
            };
            document.addEventListener('hoshiki:palette:updated', check);
            btn.addEventListener('click', function once() {
              setTimeout(function() {
                if (isGarnetInPalette()) step2();
                else document.addEventListener('hoshiki:palette:updated', check);
              }, 300);
            }, { once: true });
          } else {
            setAllowedTargets(null);
            showBubble(getStr('tutorial_add_garnet') + ' ' + getStr('tutorial_fallback_garnet'), null, true, step2, endTutorial);
          }
        }, step1Delay);
      }

      // Step 2a: パレットを開く（クリックさせる）
      function step2() {
        var fab = document.getElementById('palette-fab');
        if (fab) scrollToElement(fab, 'center');
        setTimeout(function() {
          setAllowedTargets(fab || null);
          updateSpotlightMobileSafe(overlay, fab);
          showBubble(getStr('tutorial_open_palette'), fab, false, null, endTutorial);
          if (fab) {
            var modal = document.getElementById('palette-modal');
            fab.addEventListener('click', function once() {
              setTimeout(function() {
                if (modal && modal.style.display === 'block') step2b();
                else showBubble(getStr('tutorial_open_palette'), null, true, step3, endTutorial);
              }, 200);
            }, { once: true });
          } else {
            showBubble(getStr('tutorial_open_palette'), null, true, step3, endTutorial);
          }
        }, ANIM_DURATION + 50);
      }

      // Step 2b: パレット全体ハイライト、「次へ」で閉じるステップへ
      function step2b() {
        var modal = document.getElementById('palette-modal');
        setTimeout(function() {
          setAllowedTargets(null);
          updateSpotlightMobileSafe(overlay, modal);
          showBubble(getStr('tutorial_palette_opened'), modal, true, step2c, endTutorial);
        }, 200);
      }

      // Step 2c: お気に入りパレットボタンのみハイライト、タップで閉じさせる
      function step2c() {
        var fab = document.getElementById('palette-fab');
        var modal = document.getElementById('palette-modal');
        var closeBtn = modal && modal.querySelector('.palette-panel-close, .horoscope-modal-close');
        setTimeout(function() {
          setAllowedTargets(fab && closeBtn ? [fab, closeBtn] : (fab || null));
          updateSpotlightMobileSafe(overlay, fab);
          showBubble(getStr('tutorial_palette_close'), fab, false, null, endTutorial);
          function advance() {
            fab.removeEventListener('click', handler);
            var cb = modal && modal.querySelector('.palette-panel-close, .horoscope-modal-close');
            if (cb) cb.removeEventListener('click', handler);
            step3();
          }
          function handler() { setTimeout(function() { if (modal && modal.style.display !== 'block') advance(); }, 150); }
          if (fab) fab.addEventListener('click', handler);
          if (closeBtn) closeBtn.addEventListener('click', handler);
        }, 200);
      }

      // Step 3–5: タブを1つずつハイライト（MBTI→誕生石→タロット）
      function step3() {
        var diag = document.getElementById('hoshiki-diagnosis');
        if (diag) scrollToElement(diag, 'center');
        clickTab('tab-mbti');
        setTimeout(function() {
          var tabTarget = isMobile() ? (document.querySelector('.finder-tabs') || document.querySelector('.tab-link[data-tab="tab-mbti"]')) : document.querySelector('.tab-link[data-tab="tab-mbti"]');
          var mbtiTab = document.querySelector('.tab-link[data-tab="tab-mbti"]');
          updateSpotlightMobileSafe(overlay, tabTarget || mbtiTab);
          showBubble(getStr('tutorial_tab_mbti'), tabTarget || mbtiTab, true, step4, endTutorial);
        }, isMobile() ? 700 : 500);
      }

      function step4() {
        setAllowedTargets(null);
        clickTab('tab-birthstone');
        setTimeout(function() {
          var birthTab = document.querySelector('.tab-link[data-tab="tab-birthstone"]');
          updateSpotlightMobileSafe(overlay, birthTab);
          showBubble(getStr('tutorial_tab_birthstone'), birthTab, true, step5, endTutorial);
        }, isMobile() ? 600 : 400);
      }

      function step5() {
        setAllowedTargets(null);
        var diagSection = document.getElementById('hoshiki-diagnosis');
        if (diagSection) scrollToElement(diagSection, 'center');
        clickTab('tab-tarot');
        function tryShowTarotStep() {
          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              var tabTarot = document.getElementById('tab-tarot');
              if (!tabTarot || !tabTarot.classList.contains('active')) return;
              var grid = tabTarot.querySelector('.tarot-left') || tabTarot.querySelector('#tarot-grid') || tabTarot.querySelector('.tarot-cards-grid');
              var cardWrappers = tabTarot.querySelectorAll('.tarot-card-wrapper');
              var cards = tabTarot.querySelectorAll('.tarot-card');
              var cardContainer = grid || (cards.length ? cards[0].parentElement : null);
              var target = null;
              if (cardContainer) {
                var r = cardContainer.getBoundingClientRect();
                if (r.width >= 20 && r.height >= 20) {
                  target = cardContainer;
                }
              }
              if (!target) {
                var header = tabTarot.querySelector('.tarot-header-row') || tabTarot.querySelector('.tarot-question-area');
                var fallbackEl = header || cardContainer;
                if (fallbackEl) {
                  var r = fallbackEl.getBoundingClientRect();
                  if (r.width >= 20 && r.height >= 20) target = fallbackEl;
                }
              }
              if (!target) target = tabTarot.querySelector('.tarot-container') || tabTarot.querySelector('.tool-content');
              if (target) {
                var tr = target.getBoundingClientRect();
                if (tr.width < 20 || tr.height < 20) target = null;
              }
              if (!target) return;
              var hasCards = cardWrappers.length > 0 || cards.length > 0;
              var clickables = hasCards ? (cardWrappers.length ? cardWrappers : cards) : null;
              setAllowedTargets(clickables ? Array.prototype.slice.call(clickables) : null);
              updateSpotlightMobileSafe(overlay, target);
              var fallback = hasCards ? '' : ' ' + getStr('tutorial_fallback_tarot');
              showBubble(getStr('tutorial_tab_tarot') + fallback, target, !hasCards, !hasCards ? step6a : null, endTutorial);
              if (hasCards) {
                var cardClicked = function() {
                  Array.prototype.forEach.call(clickables, function(w) { w.removeEventListener('click', cardClicked); });
                  setTimeout(step6a, 1200);
                };
                Array.prototype.forEach.call(clickables, function(w) { w.addEventListener('click', cardClicked); });
              } else {
                var fallbackTarget = document.querySelector('.tarot-container') || document.querySelector('.tab-link[data-tab="tab-tarot"]');
                if (fallbackTarget) {
                  var fr = fallbackTarget.getBoundingClientRect();
                  if (fr.width >= 20 && fr.height >= 20) updateSpotlightMobileSafe(overlay, fallbackTarget);
                }
                showBubble(getStr('tutorial_tab_tarot') + ' ' + getStr('tutorial_fallback_tarot'), fallbackTarget, true, step6a, endTutorial);
              }
            });
          });
        }
        setTimeout(tryShowTarotStep, 700);
      }

      // Step 6a: ～～が選ばれました（説明欄ボックス全体ハイライト）
      function step6a() {
        setAllowedTargets(null);
        var resultArea = document.getElementById('tarot-result-area');
        if (resultArea) resultArea.classList.remove('hidden');
        var todayMsgEl = document.querySelector('.tarot-result-card .badge') || document.querySelector('.tarot-result-card');
        if (todayMsgEl) scrollToElement(todayMsgEl, 'start');
        setTimeout(function() {
          var resultCard = document.querySelector('.tarot-result-card');
          var stoneLink = document.querySelector('#tarot-stone-link');
          var stoneName = (stoneLink && stoneLink.textContent && stoneLink.textContent.trim()) || '選ばれた石';
          var addBtn = document.querySelector('#tarot-result-area .add-to-palette-diagnosis-btn') || document.querySelector('#tarot-cta .add-to-palette-btn');
          if (!stoneName || stoneName === '--') {
            if (addBtn && addBtn.dataset.variantId && window.hoshikiGemProduct && window.hoshikiGemProduct.variants) {
              var vid = addBtn.dataset.variantId;
              var nodes = window.hoshikiGemProduct.variants.edges.map(function(e) { return e.node; });
              var v = nodes.find(function(n) { return String(n.id) === String(vid); });
              if (v && v.stone_name && v.stone_name.value) {
                var raw = v.stone_name.value;
                var parts = raw.split(',').map(function(s) { return s.trim(); });
                var lang = (document.documentElement.lang || 'ja').toLowerCase();
                stoneName = parts[lang === 'zh-tw' || lang === 'zh' ? 2 : (lang === 'en' ? 1 : 0)] || parts[0] || v.title || stoneName;
              } else if (v && v.title) stoneName = v.title;
            }
          }
          if (!stoneName || stoneName === '--') stoneName = '選ばれた石';
          var selectedMsg = (getStr('tutorial_tarot_selected') || '{name}が選ばれました。').replace(/\{name\}/g, stoneName);
          var highlightEl = resultCard || resultArea;
          if (highlightEl) updateSpotlightMobileSafe(overlay, highlightEl);
          showBubble(selectedMsg, highlightEl, true, function() { step6b(stoneName); }, endTutorial);
        }, 900);
      }

      // Step 6b: さっそく～～を追加してみましょう（＋ボタンのみハイライト）
      function step6b(stoneName) {
        setTimeout(function() {
          var addBtn = document.querySelector('#tarot-result-area .add-to-palette-diagnosis-btn') || document.querySelector('#tarot-cta .add-to-palette-btn');
          setAllowedTargets(addBtn || null);
          if (!addBtn) {
            step7();
            return;
          }
          var addMsg = (getStr('tutorial_tarot_add') || 'さっそく{name}を追加してみましょう。').replace(/\{name\}/g, stoneName || '選ばれた石');
          updateSpotlightMobileSafe(overlay, addBtn);
          showBubble(addMsg, addBtn, false, null, endTutorial);
          var check = function() {
            var list = window.HoshikiPalette && window.HoshikiPalette.getPalette ? window.HoshikiPalette.getPalette() : [];
            if (list.length >= 2) {
              document.removeEventListener('hoshiki:palette:updated', check);
              step7();
            }
          };
          addBtn.addEventListener('click', function once() {
            setTimeout(function() {
              var list = window.HoshikiPalette && window.HoshikiPalette.getPalette ? window.HoshikiPalette.getPalette() : [];
              if (list.length >= 2) step7();
              else document.addEventListener('hoshiki:palette:updated', check);
            }, 400);
          }, { once: true });
        }, 200);
      }

      // Step 7: パレットで2つ選択
      function step7() {
        if (!window.HoshikiPalette || !window.HoshikiPalette.isPaletteOpen || !window.HoshikiPalette.isPaletteOpen()) {
          openPalette();
        }
        var listEl = document.getElementById('palette-list');
        setTimeout(function() {
          setAllowedTargets(listEl ? function(el) {
            return listEl.contains(el) && el.closest('li[data-item-id]');
          } : null);
          updateSpotlightMobileSafe(overlay, listEl);
          showBubble(getStr('tutorial_select_two'), listEl, false, null, endTutorial);
          function checkAndAdvance() {
            if (!listEl) return;
            var sel = listEl.querySelectorAll('li[data-item-id].selected');
            if (sel.length >= 2) {
              listEl.removeEventListener('click', onListClick);
              step8();
            }
          }
          function onListClick() {
            setTimeout(checkAndAdvance, 150);
          }
          if (listEl) listEl.addEventListener('click', onListClick);
          checkAndAdvance();
        }, 400);
      }

      // Step 8: カスタマイズを開始
      function step8() {
        var ctaContainer = document.getElementById('palette-cta-container');
        setTimeout(function() {
          var ctaBtn = ctaContainer ? ctaContainer.querySelector('.dynamic-cta') : null;
          setAllowedTargets(ctaBtn || ctaContainer || null);
          if (ctaBtn) {
            updateSpotlightMobileSafe(overlay, ctaBtn);
            showBubble(getStr('tutorial_start_customize'), ctaBtn, false, null, endTutorial);
            ctaBtn.addEventListener('click', function once() {
              setTimeout(step9, 300);
            }, { once: true });
          } else {
            updateSpotlightMobileSafe(overlay, ctaContainer);
            showBubble(getStr('tutorial_start_customize') + ' ' + getStr('tutorial_fallback_cta'), ctaContainer, true, step9, endTutorial);
          }
        }, 400);
      }

      // Step 9: フレーム選択で終了（デザインを選ぶの真下にバブル表示、チュートリアルを終了ボタン）
      function step9() {
        var modal = document.getElementById('design-choice-modal');
        setAllowedTargets(modal || null);
        function showFrameDoneBubble() {
          if (bubble) { bubble.remove(); resizeCb && window.removeEventListener('resize', resizeCb); }
          updateSpotlight(overlay, null);
          var frameDoneText = getStr('tutorial_frame_done');
          var anchor = modal ? modal.querySelector('.design-choice-options') || modal.querySelector('.design-choice-content') : document.getElementById('design-choice-title-h3');
          if (!anchor) anchor = document.getElementById('design-choice-title-h3');
          function doEndTutorial() {
            if (modal) {
              modal.classList.remove('is-active');
              modal.hidden = true;
            }
            smoothScrollTo(0, SCROLL_DURATION);
            setTimeout(endTutorial, 100);
          }
          bubble = createFrameDoneBubble(frameDoneText, doEndTutorial);
          bubble.style.zIndex = '10011';
          document.body.appendChild(bubble);
          function positionBubbleBelow(bub, anchor) {
            if (!bub || !anchor) return;
            var vw = window.innerWidth;
            var vh = window.innerHeight;
            var r = anchor.getBoundingClientRect();
            var br = bub.getBoundingClientRect();
            var pad = isMobile() ? 16 : 24;
            var bottomPad = isMobile() ? (MOBILE_BOTTOM_NAV + 100) : 48;
            var x = Math.max(pad, Math.min(vw - br.width - pad, (vw - br.width) / 2));
            var y = r.bottom + pad;
            y = Math.min(y, vh - br.height - bottomPad);
            y = Math.max(pad, y);
            bub.style.left = x + 'px';
            bub.style.top = y + 'px';
          }
          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              positionBubbleBelow(bubble, anchor);
            });
          });
          resizeCb = function() { positionBubbleBelow(bubble, anchor); };
          window.addEventListener('resize', resizeCb);
        }
        var checkModal = function() {
          if (modal && (modal.classList.contains('is-active') || !modal.hidden)) {
            document.removeEventListener('hoshiki:palette:updated', checkModal);
            showFrameDoneBubble();
          }
        };
        document.addEventListener('hoshiki:palette:updated', checkModal);
        setTimeout(function() {
          if (modal && (modal.classList.contains('is-active') || !modal.hidden)) {
            showFrameDoneBubble();
          } else {
            checkModal();
          }
        }, 500);
      }

      step1();
    }).catch(function() {
      trigger.disabled = false;
    });
  }

  var STORAGE_KEY = 'hoshiki_tutorial_seen';

  function isFirstVisit() {
    try {
      return !localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return false;
    }
  }

  function markTutorialSeen() {
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {}
  }

  function updateFirstVisitGlow() {
    var trigger = document.getElementById('stone-tutorial-trigger');
    if (!trigger) return;
    if (isFirstVisit()) {
      trigger.classList.add('stone-tutorial-trigger--first-visit');
    } else {
      trigger.classList.remove('stone-tutorial-trigger--first-visit');
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    var trigger = document.getElementById('stone-tutorial-trigger');
    updateFirstVisitGlow();
    if (trigger) {
      trigger.addEventListener('click', function() {
        markTutorialSeen();
        trigger.classList.remove('stone-tutorial-trigger--first-visit');
        runTutorial();
      });
    }
  });
})();
